<template>
  <div>
    <h2 class="text__center">Information</h2>
    <HowTo />
    <div class="tile information--contact">
      <p class="content__heading">Contact Information</p>
      <div class="contacts">
        <Contact v-for="contact in getContacts" :key="contact.email" :contact="contact" />
      </div>
    </div>
    <div class="tile information--external">
      <p class="content__heading">External Links</p>
      <div class="flex__center">
        <a
          href="https://docs.google.com/spreadsheets/d/1NPFdaHQhUn4GqEBa-OtnJnkIpGKKcTp2cc3kjiOroWc/edit#gid=726487219"
          target="_blank"
          class="text__bold"
        >Loan Officer State Licenses</a>
      </div>
      <div class="flex__center">
        <a href="https://admin.fbhl.com/users" target="_blank" class="text__bold">Loan Officer Information</a>
      </div>
    </div>
    <h2 class="text__center">Websites</h2>
    <div class="information--websites">
      <Website v-for="website in getWebsites" :key="website.link" :website="website" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HowTo from "./HowTo";
import Contact from "./Contact";
import Website from "./Website";

export default {
  data() {
    return {
      copied: ""
    };
  },
  components: {
    HowTo,
    Contact,
    Website
  },
  computed: {
    ...mapGetters(["getWebsites", "getContacts"])
  },
  methods: {
    copyTextToClipboard(id) {
      const input = document.getElementById(id);
      input.select();
      input.setSelectionRange(0, 99999);

      document.execCommand("copy");
      this.copied = id;
      setTimeout(this.clearCopy, 1000);
    },
    clearCopy() {
      return (this.copied = false);
    }
  }
};
</script>

<style scoped lang="scss">
</style>